import * as React from "react";
import {useEffect, useState} from "react";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";
import {EtaQualityReportRequest, EtaQualityReportResponse} from "../../../../../generated/api";
import {TimedBarChart} from "./TimedBarChart";
import {Button, Dropdown, Loader} from "semantic-ui-react";
import {CustomDateRangePicker} from "../../../../util/dateRangePicker/CustomDateRangePicker";
import {Moment} from "moment";
import {Popup} from "semantic-ui-react";
import {ConfigContext} from "../../../context/ConfigContext";

export interface EtaQualityPageProps {

}

enum EtaQualityMonitoringSelectedDataSet {
    CALCULATION_ERROR = "CALCULATION_ERROR",
    ADDED_STATIC_ERROR = "ADDED_STATIC_ERROR",
    MIN_SLACK_TIME = "MIN_SLACK_TIME",
    MAX_SLACK_TIME = "MAX_SLACK_TIME",
}

export function EtaQualityPage(props: React.PropsWithChildren<EtaQualityPageProps>) {

    const context = React.useContext(ConfigContext);

    const [response, setResponse] = useState<EtaQualityReportResponse | null>(null);
    const [data, setData] = useState<any>(null);
    const [selectedDataSet, setSelectedDataSet] = useState<EtaQualityMonitoringSelectedDataSet>(EtaQualityMonitoringSelectedDataSet.CALCULATION_ERROR);
    const [isLoading, setIsLoading] = useState(false);
    const [fromDate, setFromDate] = useState<Moment | null>(null);
    const [toDate, setToDate] = useState<Moment | null>(null);
    const [searchInAllCompanies, setSearchInAllCompanies] = useState(true);

    useEffect(() => {

        fetchEtaQualityReport().then((r) => {
            switchDataSet(r)
        })


    }, [])

    function switchDataSet(r: EtaQualityReportResponse = response) {
        if (r) {
            switch (selectedDataSet) {
                case EtaQualityMonitoringSelectedDataSet.CALCULATION_ERROR: {
                    let newData = r.days.map((day) => {
                        return {
                            name: day.date,
                            value: day.averageCalculationErrorInMin
                        }
                    })
                    setData(newData)
                    break;
                }
                case EtaQualityMonitoringSelectedDataSet.ADDED_STATIC_ERROR: {
                    let newData = r.days.map((day) => {
                        return {
                            name: day.date,
                            value: day.averageAddedStaticOffsetInMin
                        }
                    })
                    setData(newData)
                    break;
                }
                case EtaQualityMonitoringSelectedDataSet.MIN_SLACK_TIME: {
                    let newData = r.days.map((day) => {
                        return {
                            name: day.date,
                            value: day.averageMinSlackTimeInMin
                        }
                    })
                    setData(newData)
                    break;
                }
                case EtaQualityMonitoringSelectedDataSet.MAX_SLACK_TIME: {
                    let newData = r.days.map((day) => {
                        return {
                            name: day.date,
                            value: day.averageMaxSlackTimeInMin
                        }
                    })
                    setData(newData)
                    break;
                }
            }
        }
    }

    async function fetchEtaQualityReport(
        startDate: Moment = fromDate,
        endDate: Moment = toDate,
        allCompanies: boolean = searchInAllCompanies
    ) {
        setIsLoading(true)
        try {
            const request = {} as EtaQualityReportRequest;

            request.from = startDate.toDate()
            request.to = endDate.toDate()
            request.companyId = allCompanies ? undefined : context.companyId


            const auth = backend.withTokenAuthHeader(authentication.token);
            const response = await backend.internalApi.fetchEtaQualityReport(
                request,
                auth
            );

            setResponse(response);
            setIsLoading(false)
            return response;
        } catch (error) {
            console.error("Error fetching ETA quality report:", error);
            setIsLoading(false)
            return null;
        }
    }

    function displayGraph() {

        console.log("ETA Quality Report Chart redraw : ", data)
        return <TimedBarChart
            key={selectedDataSet}
            data={data}
            loading={isLoading}
            containerId="parent-id"
        />
    }

    function drawDataSetSelection() {
        return <Dropdown
            id="dataSet"
            selection
            value={selectedDataSet}
            onChange={(e, {value}) => {
                setSelectedDataSet(value as EtaQualityMonitoringSelectedDataSet);
                switchDataSet();
            }}
            options={Object.values(EtaQualityMonitoringSelectedDataSet).map((value) => ({
                key: value,
                text: value,
                value: value,
            }))}
        />
    }

    function drawDaysInPastSelector() {
        return <>
            <CustomDateRangePicker
                id={"EtaQualityDateRangePicker"}
                startDate={fromDate}
                endDate={toDate}
                onDatesSelected={(startDate?: Moment, endDate?: Moment) => {
                    setFromDate(startDate)
                    setToDate(endDate)
                    fetchEtaQualityReport(startDate, endDate).then((r) => {
                        switchDataSet(r)
                    })
                }}
            />

        </>
    }

    function drawCompanyToggle() {
        return <Popup
            trigger={<Button
                toggle
                active={searchInAllCompanies}
                onClick={() => {
                    let newSearchInAllCompanies = !searchInAllCompanies
                    setSearchInAllCompanies(newSearchInAllCompanies)
                    fetchEtaQualityReport(
                        fromDate,
                        toDate,
                        newSearchInAllCompanies
                    ).then((r) => {
                        switchDataSet(r)
                    })
                }}
            >
                {searchInAllCompanies ? "all companies" : "my company"}
            </Button>}
            content={searchInAllCompanies ? "Search in all companies" : "Search in my company"}
        />
    }

    return <>
        <h1>Eta Quality</h1>
        <div
            style={{
                flexDirection: "row",
            }}>
            {drawDataSetSelection()}
            {drawDaysInPastSelector()}
            {drawCompanyToggle()}
            {isLoading && <Loader active={isLoading}/>}
        </div>
        {response && displayGraph()}
    </>
}